import React from 'react';
import { fieldClass, helperClass, labelClass } from '../../governed-mcp-gateway/components/GatewayUi';
import ApiTypeCards from '../components/ApiTypeCards';
import { isApiSupported, resolveApiCompatibility } from '../llmGatewayConstants';
import type { GatewayApiType, GatewayFormState, RegisteredLlm } from '../llmGatewayTypes';

export default function ApiTypeStep({
  form,
  errors,
  isLight,
  models,
  onChange,
}: {
  form: GatewayFormState;
  errors: Record<string, string>;
  isLight: boolean;
  models: RegisteredLlm[];
  onChange: (next: GatewayFormState) => void;
}) {
  const model = models.find((item) => item.id === form.modelId);
  const compatibility = model ? resolveApiCompatibility(model) : [];

  const toggle = (apiType: GatewayApiType) => {
    if (!model || !isApiSupported(model, apiType)) return;
    const next = form.apiTypes.includes(apiType)
      ? form.apiTypes.filter((item) => item !== apiType)
      : [...form.apiTypes, apiType];
    onChange({ ...form, apiTypes: next });
  };

  return (
    <div className="space-y-4">
      <p className={helperClass(isLight)}>
        Compatible API types are recommended from the selected model’s serving protocol. Unsupported protocols stay disabled.
      </p>
      {model ? (
        <ApiTypeCards compatibility={compatibility} selected={form.apiTypes} onToggle={toggle} isLight={isLight} />
      ) : (
        <p className={`text-sm ${isLight ? 'text-neutral-500' : 'text-neutral-400'}`}>Select a registered LLM first.</p>
      )}
      {errors.apiTypes ? <p className="text-xs text-red-500">{errors.apiTypes}</p> : null}

      {form.apiTypes.includes('custom') ? (
        <div>
          <label className={labelClass(isLight)} htmlFor="custom-endpoint">
            Custom endpoint
          </label>
          <input
            id="custom-endpoint"
            className={fieldClass(isLight)}
            placeholder="/v1/rerank"
            value={form.customEndpoint}
            onChange={(event) => onChange({ ...form, customEndpoint: event.target.value })}
          />
          {errors.customEndpoint ? <p className="mt-1 text-xs text-red-500">{errors.customEndpoint}</p> : null}
        </div>
      ) : null}
    </div>
  );
}
